export const SET_USERS = 'SET_USERS';

export const setUser = (user) => ({
    type: SET_USERS,
    payload: user,
});

export const switchUser = (user) => ({
    type: 'SWITCH_USER',
    payload: user,
});

export const revertUser = () => ({
    type: 'REVERT_USER',
});

export const SET_URL = 'SET_URL';

export const setUrl = (url) => ({
    type: SET_URL,
    payload: url,
});

export const LOGOUT = 'LOGOUT';

export const logout = () => ({
    type: LOGOUT,
});

export const SET_FullScreen = 'SET_FullScreen';

export const setFullScreen = (screenstate) => ({
    type: SET_FullScreen,
    payload: screenstate,
});
